import React from 'react';
import { Linkedin, Mail } from 'lucide-react';
import TiktokIcon from './tiktokIcon';
import { FooterProps } from '../types/components';

const Footer: React.FC<FooterProps> = ({ texts }) => {

  return (
    <footer className="bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200 py-6 mt-12">
      <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between items-center">
        {/* Left side / Copyright */}
        <p className="text-sm mb-4 md:mb-0"> &copy; {new Date().getFullYear()} {texts.footer.myPortfolio} - {texts.footer.name}</p>
        {/* Right side / Social icons */}
        <div className="flex space-x-4">
          {/* LinkedIn */}
          <a href="https://www.linkedin.com/in/anton-joncour-colombel-a43408346/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500 transition-colors" aria-label="LinkedIn">
            <Linkedin className="w-5 h-5" />
          </a>

          {/* TikTok */}
          <a href="https://www.tiktok.com/@your-username" target="_blank" rel="noopener noreferrer" className="hover:text-pink-500 transition-colors" aria-label="TikTok">
            <TiktokIcon className="w-5 h-5" />
          </a>

          {/* Email */}
          <a href="mailto:your.email@domain.com" className="hover:text-red-600 transition-colors" aria-label="Email">
            <Mail className="w-5 h-5" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
